import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState
} from 'react';
import DateBox from 'devextreme-react/date-box';
import DataGrid, { Column } from 'devextreme-react/data-grid';
import { Editing, RequiredRule } from 'devextreme-react/gantt';
import { ValidationGroup, Validator } from 'devextreme-react';
import { formatMessage } from 'devextreme/localization';
import style from './savedProductsTable.module.scss';
import { getCompatibleForm, getRenderField, trim } from '../../../utils/functions';
import styles from '../../DataGridMVP/datagridmvp.module.scss';
import columnDataGrid from '../InputModalReadyProducts/columnDataGrid';
import convertWeightUnit, { getUnit } from '../../../utils/weight_converter';
import PopupErrorMVP from '../../PopupErrorMVP';

const InputModalSavedProducts = ({
  settingsReducer: { settings },
  savedProductsReducer,
  getZdvlByTask,
  isValidFields,
  plantId,
  selectedPieces,
  setCapacityAvailable,
  setCapacityPipe,
  setLengthField,
  setMarkField,
  setNormativeDocField,
  setOnModalSave,
  setPieceIdField,
  setPlantOperationAttribsInherit,
  setProductUnit,
  setProfileSizeField,
  setQcDateField,
  setQcIdField,
  setQuantityField,
  setQuantityOff,
  setReadyProductsPieces,
  saveEditableData,
  setThicknessField,
  setValidateInstance,
  setZdvlLineNumId,
  useFactWeight,
  visibleModal
}) => {
  const tableRef = useRef(null);
  // eslint-disable-next-line
  const [state, setState] = useState({
    editRowKey: {
      batchId: null,
      cgId: null,
      actualPieceId: null,
      quantity: null,
      quantityRemain: null,
      percentWasteMaterial: null,
      quantityCurrent: null,
      weightWasteMaterialCurrent: null,
      quantityOff: null,
      pieceNumId: null
    }
  });

  const [editableData, setEditableData] = useState(savedProductsReducer.inputPieces);
  const [isWeightable, setIsWeightable] = useState(false);
  const [isFocusItems, setIsFocusItems] = useState({
    zdvlLineNumId: false,
    qcId: false,
    pieceId: false,
    quantity: false,
    quantityOff: false
  });
  const [visiblePopupCapacityAvailable, setVisiblePopupCapacityAvailable] = useState(false);

  const isWeightUnits = (units) => units.every((unit) => !!getUnit(unit));

  const productUnitString = useMemo(() => {
    if (savedProductsReducer.zdvlByTask.length) return `, ${savedProductsReducer.zdvlByTask[0].capacityPipeMeasureShort}`;
    return '';
  }, [savedProductsReducer]);

  useEffect(() => {
    let parentUnit = '';
    if (savedProductsReducer.productUnit) {
      parentUnit = savedProductsReducer.productUnit;
    }
    const mappedUnits = savedProductsReducer.inputPieces.map((item) => item.unitShortName);
    let isAllUnitsWeightable;
    if (savedProductsReducer.zdvlByTask.length) {
      isAllUnitsWeightable = !!getUnit(savedProductsReducer.zdvlByTask[0].capacityPipeMeasureShort);
    } else {
      isAllUnitsWeightable = isWeightUnits(mappedUnits) && !!getUnit(parentUnit);
    }
    setIsWeightable(isAllUnitsWeightable);
  }, [
    savedProductsReducer.inputPieces,
    savedProductsReducer.productUnit,
    savedProductsReducer.zdvlByTask
  ]);
  const validatorRef = useRef(null);

  const getDataByLineId = useCallback(
    (line) => {
      if (
        savedProductsReducer.zdvlByTask.length
        && savedProductsReducer.zdvlLineNumId
        && line
      ) {
        const zdvlBySelectedLine = savedProductsReducer.zdvlByTask.find(
          (el) => el.zdvlLineNumId === line
        );
        return {
          mark: zdvlBySelectedLine && zdvlBySelectedLine.markPipe,
          normativeDoc: zdvlBySelectedLine && zdvlBySelectedLine.standardPipe,
          length: zdvlBySelectedLine && zdvlBySelectedLine.lengthPipe,
          profileSize: zdvlBySelectedLine && zdvlBySelectedLine.sizePipe,
          thickness: zdvlBySelectedLine && zdvlBySelectedLine.thicknessPipe,
          capacityPipe: zdvlBySelectedLine && zdvlBySelectedLine.capacityPipe,
          capacityAvailable:
            zdvlBySelectedLine && zdvlBySelectedLine.capacityAvailable
        };
      }
      return null;
    },
    [savedProductsReducer.zdvlByTask, savedProductsReducer.zdvlLineNumId]
  );

  // TODO переделать setQuantityField для склада МЕТЕК ПФ
  useEffect(() => {
    const selectedData = getDataByLineId(savedProductsReducer.zdvlLineNumId);
    if (savedProductsReducer.zdvlLineNumId && selectedData) {
      setMarkField(selectedData.mark);
      setNormativeDocField(selectedData.normativeDoc);
      setLengthField(selectedData.length);
      setProfileSizeField(selectedData.profileSize);
      setThicknessField(selectedData.thickness);
      if (plantId === '8045') {
        setQuantityField(1);
      }
      setCapacityPipe(selectedData.capacityPipe);
      setCapacityAvailable(selectedData.capacityAvailable);
    } else {
      setMarkField(null);
      setNormativeDocField(null);
      setLengthField(null);
      setProfileSizeField(null);
      setThicknessField(null);
      setQuantityField(0);
      setCapacityPipe(null);
      setCapacityAvailable(null);
      setProductUnit(null);
    }
  }, [
    getDataByLineId,
    plantId,
    savedProductsReducer.zdvlLineNumId,
    savedProductsReducer.zdvlByTask,
    setCapacityAvailable,
    setCapacityPipe,
    setLengthField,
    setMarkField,
    setNormativeDocField,
    setProfileSizeField,
    setThicknessField,
    setProductUnit,
    setQuantityField
  ]);

  // useEffect(() => {
  //   setQcDateField(new Date());
  //   if (useFactWeight && savedProductsReducer.quantity !== savedProductsReducer.quantityOff) {
  //     setQuantityField(savedProductsReducer.quantityOff);
  //   }
  // }, [
  //   savedProductsReducer.quantity,
  //   savedProductsReducer.quantityOff,
  //   setQcDateField,
  //   setQuantityField,
  //   useFactWeight
  // ]);

  useEffect(() => {
    if (
      selectedPieces
      && selectedPieces.length
      && visibleModal
      && selectedPieces[0].taskNumId
    ) {
      getZdvlByTask({ taskNumId: selectedPieces[0].taskNumId });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getZdvlByTask, visibleModal]);

  const renderMark = useMemo(
    () =>
      getRenderField({
        state: savedProductsReducer.mark,
        form: 'string'
      }),
    [savedProductsReducer.mark]
  );

  const renderNormativeDoc = useMemo(
    () =>
      getRenderField({
        state: savedProductsReducer.normativeDoc,
        form: 'string'
      }),
    [savedProductsReducer.normativeDoc]
  );

  const renderLength = useMemo(
    () =>
      getRenderField({
        state: savedProductsReducer.length,
        form: 'number'
      }),
    [savedProductsReducer.length]
  );

  const renderPieceId = useMemo(
    () => (
      getRenderField({
        state: savedProductsReducer.pieceId,
        setState: setPieceIdField,
        form: 'string',
        validation: null,
        isValid: isFocusItems.pieceId || (trim(savedProductsReducer.pieceId, ' ') !== '' || !!isValidFields.pieceId),
        validationError: formatMessage('textError').enterPieceId,
        onFocusIn: () => setIsFocusItems({
          zdvlLineNumId: false,
          qcId: false,
          pieceId: true,
          quantity: false,
          quantityOff: false
        })
      })),
    [
      isFocusItems.pieceId,
      isValidFields.pieceId,
      savedProductsReducer.pieceId,
      setPieceIdField
    ]
  );

  const renderProfileSize = useMemo(
    () =>
      getRenderField({
        state: savedProductsReducer.profileSize,
        form: 'string'
      }),
    [savedProductsReducer.profileSize]
  );

  const renderCapacityPipe = useMemo(
    () =>
      getRenderField({
        state: savedProductsReducer.capacityPipe,
        form: 'number'
      }),
    [savedProductsReducer.capacityPipe]
  );

  const renderCapacityAvailable = useMemo(
    () =>
      getRenderField({
        state: savedProductsReducer.capacityAvailable,
        form: 'number'
      }),
    [savedProductsReducer.capacityAvailable]
  );

  const renderInputGP = useMemo(
    () =>
      getRenderField({
        state: savedProductsReducer.readyProductsBySemi.sum('weightOff'),
        form: 'number'
      }),
    [savedProductsReducer]
  );

  const renderInheritanceFields = useMemo(() => {
    if (savedProductsReducer.plantOperationAttribsInheritDtos
      && savedProductsReducer.plantOperationAttribsInheritDtos.length) {
      return savedProductsReducer.plantOperationAttribsInheritDtos.map(
        (item) => (
          <div className={style.line} key={item.attribCode}>
            <span>{`${item.attribDescr}${item.unitShort ? `, ${item.unitShort}` : ''}:`}</span>
            {getRenderField({
              state: item.value,
              setState: (value) => {
                const newData = savedProductsReducer
                  .plantOperationAttribsInheritDtos
                  .map((data) => item.attribCode === data.attribCode
                    ? ({ ...data, value }) : data);
                setPlantOperationAttribsInherit(newData);
              },
              form: getCompatibleForm(item.sapAttribType)
            })}
          </div>
        )
      );
    }
    return <></>;
  }, [savedProductsReducer.plantOperationAttribsInheritDtos, setPlantOperationAttribsInherit]);

  const renderZdvlLineNumId = useMemo(() => (
    getRenderField({
      state: [
        ...new Map(
          settings.useProductionLg
            ? savedProductsReducer.zdvlByTask.map((item) => [
              item.zdvlLineNumId,
              item
            ])
            : savedProductsReducer.zdvlByTask
              .filter((el) => !!el.capacityAvailable)
              .map((item) => [item.zdvlLineNumId, item])
        ).values()
      ].map((el) => ({
        key: `${el.orderId} ${el.lineId}`,
        value: el.zdvlLineNumId
      })),
      loading: savedProductsReducer.zdvlByTaskGet.loading,
      setState: (value) => {
        let zdvlUnit = null;
        let pieceId = null;
        // let qcId = null;
        if (value) {
          zdvlUnit = savedProductsReducer.zdvlByTask.find(
            (el) => el.zdvlLineNumId === value
          ).weightCoilMeasureShort;
          pieceId = savedProductsReducer.zdvlByTask.find(
            (el) => el.zdvlLineNumId === value
          ).lineId;
          // qcId = savedProductsReducer.zdvlByTask.find(
          //   (el) => el.zdvlLineNumId === value
          // ).orderId;
        }
        if (plantId === '8045') {
          if (value) {
            setPieceIdField(pieceId);
            setQcIdField('Б/Н');
            setQuantityOff(1);
            setQuantityField(1);
          } else {
            setPieceIdField('');
            setQcIdField('');
          }
        }
        setZdvlLineNumId(value);
        setProductUnit(zdvlUnit);
      },
      form: 'array',
      validation: null,
      isValid: isFocusItems.zdvlLineNumId || (trim(savedProductsReducer.zdvlLineNumId, ' ') !== '' || !!isValidFields.zdvlLineNumId),
      validationError: formatMessage('textError').selectZdvlLineNumId,
      onFocusIn: () => setIsFocusItems({
        zdvlLineNumId: true,
        qcId: false,
        pieceId: false,
        quantity: false,
        quantityOff: false
      }),
      onOpened: ({ component }) => {
        // Список элементов, доступных в селекте
        const zdvlList = component._options.items;
        if (!zdvlList.length) {
          setVisiblePopupCapacityAvailable(true);
        }
      }
    })),
  [
    settings.useProductionLg,
    savedProductsReducer.zdvlByTask,
    savedProductsReducer.zdvlByTaskGet.loading,
    savedProductsReducer.zdvlLineNumId,
    isFocusItems.zdvlLineNumId,
    isValidFields.zdvlLineNumId,
    plantId,
    setZdvlLineNumId,
    setProductUnit,
    setPieceIdField,
    setQcIdField,
    setQuantityOff,
    setQuantityField
  ]);

  const renderQcDate = useMemo(
    () => (
      <DateBox
        value={savedProductsReducer.qcDate || new Date()}
        displayFormat="dd.MM.yyyy"
        stylingMode="filled"
        placeholder=""
        onContentReady={() =>
          !savedProductsReducer.qcDate && setQcDateField(new Date())}
        onValueChanged={({ value }) => {
          if (value !== null) {
            setQcDateField(value);
          } else if (savedProductsReducer.qcDate === null) {
            setQcDateField(value);
          }
        }}
        width={300}
        showClearButton
        max={new Date()}
      >
        <Validator>
          <RequiredRule />
        </Validator>
      </DateBox>
    ),
    [savedProductsReducer.qcDate, setQcDateField]
  );

  const renderQcId = useMemo(
    () => (
      getRenderField({
        state: savedProductsReducer.qcId,
        setState: setQcIdField,
        form: 'string',
        validation: null,
        isValid: isFocusItems.qcId || (trim(savedProductsReducer.qcId, ' ') !== '' || !!isValidFields.qcId),
        validationError: formatMessage('textError').enterQcId,
        onFocusIn: () => setIsFocusItems({
          zdvlLineNumId: false,
          qcId: true,
          pieceId: false,
          quantity: false,
          quantityOff: false
        })
      })),
    [isFocusItems.qcId, savedProductsReducer.qcId, setQcIdField, isValidFields]
  );

  const renderThickness = useMemo(
    () =>
      getRenderField({
        state: savedProductsReducer.thickness,
        form: 'number'
      }),
    [savedProductsReducer.thickness]
  );

  const renderQuantityOff = useMemo(
    () =>
      getRenderField({
        state: savedProductsReducer.quantityOff,
        form: 'number',
        setState: !isWeightable && setQuantityOff,
        validation: null,
        isValid: isFocusItems.quantityOff || (trim(savedProductsReducer.quantityOff, ' ') !== '' || !!isValidFields.quantityOff),
        validationError: formatMessage('textError').enterQuantityOff,
        onFocusIn: () => setIsFocusItems({
          zdvlLineNumId: false,
          qcId: false,
          pieceId: false,
          quantity: false,
          quantityOff: true
        })
      }),
    [
      savedProductsReducer.quantityOff,
      isWeightable,
      setQuantityOff,
      isFocusItems.quantityOff,
      isValidFields.quantityOff
    ]
  );

  const renderQuantity = useMemo(
    () =>
      getRenderField({
        state: savedProductsReducer.quantity,
        setState: setQuantityField,
        form: 'number',
        validation: null,
        isValid: isFocusItems.quantity || (trim(savedProductsReducer.quantity, ' ') !== '' || !!isValidFields.quantity),
        validationError: formatMessage('textError').enterQuantity,
        onFocusIn: () => setIsFocusItems({
          zdvlLineNumId: false,
          qcId: false,
          pieceId: false,
          quantity: true,
          quantityOff: false
        })
      }),
    [
      isFocusItems.quantity,
      isValidFields.quantity,
      savedProductsReducer.quantity,
      setQuantityField
    ]
  );

  useEffect(() => {
    setEditableData(savedProductsReducer.inputPieces);
  }, [savedProductsReducer.inputPieces]);

  const onEditingStart = useCallback(
    (e) => {
      setState({ editRowKey: e.key });
    },
    [setState]
  );

  const dataSource = useMemo(() => savedProductsReducer.inputPieces.map((item) => ({
    ...item,
    // eslint-disable-next-line no-restricted-globals
    percentWasteMaterial: isNaN(item.percentWasteMaterial) ? 0 : item.percentWasteMaterial
  })), [
    savedProductsReducer.inputPieces
  ]);

  const calculateWeight = (data) =>
    data
      .map((el) => savedProductsReducer.productUnit !== el.unitShortName
        ? convertWeightUnit(
          el.quantityCurrent + el.quantityOff,
          el.unitShortName,
          savedProductsReducer.productUnit
        )
        : el.quantityCurrent + el.quantityOff)
      .reduce((acc, el) => acc + el, 0)
      .toFixed(3);

  const onEditorPrepared = useCallback(
    (e) => {
      e.editorOptions.valueChangeEvent = 'input';
      e.editorOptions.onValueChanged = (args) => {
        e.setValue(args.value);
        const actualRow = e.row.data;
        const updatedData = editableData.map((el) => {
          if (
            el.actualPieceId === actualRow.actualPieceId
            && el.batchId === actualRow.batchId
            && el.cgId === actualRow.cgId
          ) {
            return actualRow;
          }
          return el;
        });
        setEditableData(updatedData);
      };
    },
    [editableData]
  );

  useEffect(() => {
    if (tableRef) {
      setOnModalSave(() => async () => {
        await tableRef.current.instance.saveEditData();
        await new Promise((resolve) => {
          setReadyProductsPieces(editableData);
          resolve();
        });
        if (isWeightable) {
          await new Promise((resolve) => {
            setQuantityOff(Number(calculateWeight(editableData)));
            resolve();
          });
        }
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    editableData,
    isWeightable,
    setOnModalSave,
    setReadyProductsPieces,
    setQuantityOff,
    tableRef
  ]);

  useEffect(() => {
    if (isWeightable) {
      setQuantityOff(Number(calculateWeight(editableData)));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    editableData,
    isWeightable,
    setQuantityOff
  ]);

  useEffect(() => {
    if (validatorRef.current) {
      setValidateInstance(validatorRef.current.instance);
    }
  }, [setValidateInstance, validatorRef]);

  useEffect(() => {
    if (validatorRef.current) {
      validatorRef.current.instance.reset();
    }
  }, [savedProductsReducer.okRequest]);

  const onHidingCapacityAvailablePopup = useCallback(() => {
    setVisiblePopupCapacityAvailable(false);
  }, []);

  // Попап с информацией о доступности остатка для заказа
  const renderPopupCapacityAvailable = useMemo(() => {
    const currentZdvl = savedProductsReducer.zdvlByTask.length
      ? savedProductsReducer.zdvlByTask[0]
      : {
        orderId: '',
        lineId: ''
      };
    return (
      <PopupErrorMVP
          types="info"
          visible={visiblePopupCapacityAvailable}
          onHiding={onHidingCapacityAvailablePopup}
          techInfo=""
          message={(
            <>{`${formatMessage('textModal').textNoCapacityAvailable} ${currentZdvl.orderId}, ${formatMessage('textModal').textNoCapacityAvailableOrder} ${currentZdvl.lineId}`}</>
)}
        />
    );
  }, [
    onHidingCapacityAvailablePopup,
    visiblePopupCapacityAvailable,
    savedProductsReducer.zdvlByTask
  ]);

  /** Модальное окно Ввод ГП - Ввод факта производства - Производство - склады переработчики ПФ */
  return (
    <ValidationGroup ref={validatorRef}>
      <div className={style.containing}>
        {renderPopupCapacityAvailable}
        <div className={style.container}>
          <div className={style.line}>
            <span>Позиция заказа:</span>
            {renderZdvlLineNumId}
          </div>
          <div className={style.line}>
            <span>Нормативный документ:</span>
            {renderNormativeDoc}
          </div>
          <div className={style.line}>
            <span>Длина:</span>
            {renderLength}
          </div>
          <div className={style.line}>
            <span>№ партии ГП (СК):</span>
            {renderQcId}
          </div>
          <div className={style.line}>
            <span>Профилеразмер:</span>
            {renderProfileSize}
          </div>
          <div className={style.line}>
            <span>Дата производства:</span>
            {renderQcDate}
          </div>
          <div className={style.line}>
            <span>№ УЕ:</span>
            {renderPieceId}
          </div>
          <div className={style.line}>
            <span>Толщина:</span>
            {renderThickness}
          </div>
          <div className={style.line}>
            <span>{`Фактическое кол-во${productUnitString}:`}</span>
            {renderQuantityOff}
          </div>
          <div className={style.line}>
            <span>Марка стали:</span>
            {renderMark}
          </div>
          <div className={style.line}>
            <span>Общий объем:</span>
            {renderCapacityPipe}
          </div>
          {!useFactWeight ? (
            <div className={style.line}>
              <span>{`Теор. кол-во${productUnitString}:`}</span>
              {renderQuantity}
            </div>
          ) : (
            <div className={style.line} />
          )}
          <div className={style.line}>
            <span>Доступно к производству:</span>
            {renderCapacityAvailable}
          </div>
          <div className={style.line}>
            <span>Количество введенной ГП:</span>
            {renderInputGP}
          </div>
          {renderInheritanceFields}
        </div>
        <DataGrid
          ref={tableRef}
          dataSource={dataSource}
          showBorders
          onEditorPreparing={onEditorPrepared}
          selectTextOnEditStart
          columnAutoWidth
          elementAttr={{
            class: `${styles.dataGrid} ${style.modalTable} shipment`
          }}
          onEditingStart={onEditingStart}
          onRowUpdated={(e) => {
            tableRef.current.instance.saveEditData();
            // eslint-disable-next-line no-param-reassign
            saveEditableData.current = editableData;
            if (isWeightable) {
              setQuantityOff(
                Number(
                  calculateWeight(
                    tableRef.current.instance.getDataSource().items()
                  )
                )
              );
            }
          }}
        >
          <Editing allowUpdating mode="cell" />
          {columnDataGrid.map((item) => (
            <Column
              dataField={item.dataField}
              caption={item.caption}
              visible={!item.notVisible}
              allowEditing={!!item.allowEditing}
              key={item.dataField}
              cellRender={item.cellRender}
              dataType={item.dataType}
              cssClass={item.cssClass}
              width={item.width ? item.width : undefined}
            >
              {item.validation}
            </Column>
          ))}
        </DataGrid>
      </div>
    </ValidationGroup>
  );
};

export default React.memo(InputModalSavedProducts);
